module.exports = __webpack_public_path__ + "static/media/PlutoBold.1c31e4c2.woff";